import { render, staticRenderFns } from "./FullTxtArtAnalysis.vue?vue&type=template&id=77b081aa&scoped=true"
import script from "./FullTxtArtAnalysis.vue?vue&type=script&lang=js"
export * from "./FullTxtArtAnalysis.vue?vue&type=script&lang=js"
import style0 from "./FullTxtArtAnalysis.vue?vue&type=style&index=0&id=77b081aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b081aa",
  null
  
)

export default component.exports